import { Form, Grid, message } from 'antd';
import { Modal } from 'components';
import { useCreateExpenses } from 'features/expenses-report/use-cases/create-expenses';
import { StyledUserModalWrapper } from 'features/users/components/modals/user-modal.styles';
import { UserFormValues } from 'features/users/components/users-filter-form';

import { ExpensesReportInfoFormItems } from './reportExpensesitem';

const { useBreakpoint } = Grid;

export const ExpensesReportViewModal = ({
  onClose,
  editdata,
}: {
  onClose: () => void;
  editdata: any;
}) => {
  const formName = 'add-expense-form';
  const screens = useBreakpoint();
  const [form] = Form.useForm<UserFormValues>();
  const { isLoading, mutate } = useCreateExpenses();

  const handleUpdate = (values: any) => {
    const payload: any = {
      FacilityId: values.facility_ids || null,
      FieldId: values.field_id || null,
      SportsId: values?.sportIds, // explicitly null
      Jan: Number(values.jan || 0),
      Feb: Number(values.feb || 0),
      Mar: Number(values.mar || 0),
      Apr: Number(values.apr || 0),
      May: Number(values.may || 0),
      Jun: Number(values.jun || 0),
      Jul: Number(values.jul || 0),
      Aug: Number(values.aug || 0),
      Sep: Number(values.sep || 0),
      Oct: Number(values.oct || 0),
      Nov: Number(values.nov || 0),
      Dec: Number(values.dec || 0),
    };

    mutate(payload, {
      onSuccess: (data: any) => {
        form.resetFields();
        message.success(data?.ResponseMessage);
        onClose();
      },
    });
  };

  return (
    <StyledUserModalWrapper>
      <Modal
        open
        centered
        className='right-modal'
        title={'Expenses Charge'}
        onCancel={onClose}
        onOk={form.submit}
        okText={'Save'}
        cancelButtonProps={{ style: { display: 'none' } }}
        width={screens.lg ? '520px' : '100%'}
        okButtonProps={{ form: formName, loading: isLoading }}
      >
        <Form<UserFormValues>
          id={formName}
          name={formName}
          form={form}
          layout='vertical'
          onFinish={handleUpdate}
        >
          <ExpensesReportInfoFormItems form={form} editdata={editdata} />
        </Form>
      </Modal>
    </StyledUserModalWrapper>
  );
};
